import { TabInfoBase } from 'app/buffer-graph/models/tab-info-base';
import { SupplierSchedule } from 'app/buffer-graph/models/suppliers-schedules/supplier-schedule';
import {ColumnSettingsBase} from "../../../slick-grid/models/column-settings-base";
import {Moment} from "moment";
import {ItemInfo} from "../item-info";

type Data = { schedules: SupplierSchedule[], canSend: boolean, columns: ColumnSettingsBase[] };
export class SuppliersSchedulesTabInfo extends TabInfoBase<Data> {
    constructor(type: string, data: Data, itemInfo: ItemInfo, startDate: Moment, endDate: Moment, sharedGuid: string) {
        super('OrdersSchedules', type, null, data, itemInfo, startDate, endDate, sharedGuid);
    }

    get id(): string {
        return SuppliersSchedulesTabInfo.id;
    }

    static readonly id = 'SSS';
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/models/suppliers-schedules/suppliers-schedules-tab-info.ts